import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, tagTypes } from "../utils/constantData";
const { job, jobs, user } = tagTypes;
export const apiSlice: any = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({ baseUrl, credentials: 'include' }),
    keepUnusedDataFor: 0, // Disable cashing
    tagTypes: [job, jobs, user],
    endpoints: builder => ({})
})